import React from 'react';
import styled from 'styled-components';
import type { FooterViewModel } from 'autogen/swagger/all';
import BottomFooter from './components/BottomFooter';
import NavigationFooter from './components/NavigationFooter';
import USPFooter from './components/USPFooter';

const StyledFooter = styled.footer`
    @media print {
        display: none;
    }
`;

export interface IFooter {
    model: FooterViewModel;
}

export default function Footer(props: IFooter): JSX.Element {
    const {
        model: { footerUsps, footerMenus, footerBottom }
    } = props;

    return (
        <StyledFooter>
            <USPFooter usps={footerUsps} />
            <NavigationFooter menus={footerMenus} />
            <BottomFooter model={footerBottom} />
        </StyledFooter>
    );
}
